<template>
  <div>
    <div style="margin-top: 1rem; display: flex;">
      <full-screen
        eid='main-dashboard'
      />
      <div style="padding-left: 1rem;">
        全螢幕
      </div>
    </div>

    <b-card id='main-dashboard' title="Performance Table Demo">
      <sag-performance-table />
    </b-card>
  </div>
</template>

<script>
import SagPerformanceTable from '@/components/sag-kan-chart/SagPerformanceTable.vue'
import { BCard } from 'bootstrap-vue'
import FullScreen from '@/components/basic/FullScreen.vue'

export default {
  name: 'KANMDTUI01',
  components: {
    BCard,
    SagPerformanceTable,
    FullScreen,
  }
}
</script>
